// extracted by mini-css-extract-plugin
export var container = "_1t-0";
export var disabled = "_1t-4";
export var fullWidth = "_1t-3";
export var lined = "_1t-1";
export var selected = "_1t-5";
export var tab = "_1t-2";